import { Auth } from 'aws-amplify';
import axios from 'axios';
import createHistory from 'history/createBrowserHistory';
import { routerMiddleware } from 'react-router-redux';
import { applyMiddleware, createStore } from 'redux';
import axiosMiddleware from 'redux-axios-middleware';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import reducer from './reducer';

export const history = createHistory();

// Build the middleware for intercepting and dispatching navigation actions
const myRouterMiddleware = routerMiddleware(history);

const axiosClient = axios.create({
    baseURL: '/rest/',
    responseType: 'json'
});

const myAxiosMiddleware = axiosMiddleware(axiosClient, {
    returnRejectedPromiseOnError: true,

    interceptors: {
        request: [
            async ({ getState, dispatch }, config) => {
                if (await Auth.currentUserInfo()) {
                    const authSession = await Auth.currentSession();
                    const jwtToken = authSession.getIdToken().getJwtToken();
                    config.headers.Authorization = jwtToken;
                }
                return config;
            }
        ]
    }
});

const getMiddleware = () => {
    return applyMiddleware(myRouterMiddleware, myAxiosMiddleware);
};

export const store = createStore(reducer, composeWithDevTools(getMiddleware()));



// WEBPACK FOOTER //
// ./src/store/index.ts